export default class PaymentTerm {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'payment-term-level-two':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'CTA klik - Vælg hvor ofte du vil betale',
                    'eventLabel': 'Klik til betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-FI-insurance':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'FI-kort aktiv',
                    'eventLabel': 'BS-inaktiv',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-BS-insurance':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Betalingsservice aktiv',
                    'eventLabel': 'BS-aktiv',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-contact-FI':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Klik - kontakt os_FI-kort',
                    'eventLabel': 'Ændre betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-correction-FI':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Klik - ret oplysninger_FI-kort',
                    'eventLabel': 'Ændre betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-correction-BS':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Klik - ret oplysninger_BS',
                    'eventLabel': 'Ændre betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-frequency-FI':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Betalingsfrekvens FI-kort',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-frequency-BS':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Betalingsfrekvens BS',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-change-date-FI':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Ændringstidspunkt_FI-kort',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-change-date-BS':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'Ændringstidspunkt_BS',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-completed-FI':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'CTA klik - gennemfør betaling_FI-kort',
                    'eventLabel': 'Ændre betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-completed-BS':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'CTA klik - gennemfør betaling_BS',
                    'eventLabel': 'Ændre betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-return-FI':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'CTA klik - tilbage_FI-kort',
                    'eventLabel': 'Ændre betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'payment-term-return-BS':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Bestem Betalingsfrekvens',
                    'eventAction': 'CTA klik - tilbage_BS',
                    'eventLabel': 'Ændre betalingsfrekvens',
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
        }
        return trackingObject;
    }
}